export const getUniqueId = async () => {
	const url = `/api/fileuploadservice/getUniqueId`;
	const options = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
		},
		body: JSON.stringify({}),
	};
	const response = await fetch(url, options);
	const data = response.json();
	return data;
};
